import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconComponent } from '@fnccr-actee/design-system';
import { TranslatePipe } from '@ngx-translate/core';
import { OnboardingInfoCardComponent } from '../../ui/onboarding-info-card/onboarding-info-card.component';

@Component({
  selector: 'app-onboarding-step-three',
  imports: [OnboardingInfoCardComponent, IconComponent, NgOptimizedImage, TranslatePipe],
  templateUrl: './onboarding-step-three.component.html',
  styleUrl: '../step.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingStepThreeComponent {}
